export default "__VITE_ASSET__BV6yuU37__"